import { useContext } from 'react';
import { RegionsContext } from '../components/context/regions.context';

export const useRegions = () => (useContext(RegionsContext) || []).filter(region => region?.type?.slug === 'kelp-region');